import React, { PropsWithChildren } from "react";

const Chip = (
  p: PropsWithChildren<{
    textColor?: string;
    bgColor?: string;
    outline?: boolean;
    rounded?: boolean;
  }>,
) => {
  return (
    <div
      className="inline-flex items-center justify-center rounded-sm border 
        border-transparent px-1 pt-0.5 text-3xs uppercase"
      style={{
        color: p.textColor || null,
        backgroundColor: p.bgColor || null,
        borderColor: (p.outline && p.textColor) || null,
        borderRadius: (p.rounded && "6px") || null,
      }}
    >
      {p.children}
    </div>
  );
};

export default Chip;
